import { NgModule } from '@angular/core';

import { AngularBaseModule } from 'src/external-modules/angular-base.module';

import { AngularDeviceInformationService } from 'angular-device-information';

import { SyncFusionModule } from 'src/external-modules/syncfusion.module';
import { MaterialDesignModule } from 'src/external-modules/material-design.module';
import { PdfViewerModule } from 'ng2-pdf-viewer';

import { HotkeyModule, IHotkeyOptions } from 'angular2-hotkeys';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'; // https://moribvndvs.github.io/ng2-idle/quickstart - this includes the core NgIdleModule but includes keepalive providers for easy wireup

import { CerViewRecreateDirective } from './cer-directives/cer-view-recreate.directive';

import { CerAuthorizeModule } from 'src/cer-identity/cer-authorize.module';
import { CerIdleService } from './cer-idle/cer-idle.service';

import { CerSessionService } from './cer-session/cer-session.service';
import { CerSessionEnvironmentService } from './cer-session/cer-session-environment.service';
import { CerSessionUserNavigationService } from './cer-session/cer-session-user-navigation.service';
import { CerSessionUserService } from './cer-session/cer-session-user.service';
import { CerSessionUsersService } from './cer-session/cer-session-users.service';

import { CerIntlService } from '@ui/cer-ui-intl.service';
import { CerLocaleService } from '@ui/cer-ui-locale.service';
import { CerUiPromptProviderService } from '@ui/cer-ui-prompt-provider.service';

import { CerFormComponent } from '@form/cer-form.component';
import { CerFormPaneComponent } from '@form/cer-form-panes/cer-form-pane/cer-form-pane.component';
import { CerFormViewComponent } from '@form/cer-form-view-type/cer-form-view.component';
import { CerFormViewTypeListComponent } from '@form/cer-form-view-type/cer-form-view-type-list.component';
import { CerFormViewTypeTreeComponent } from '@form/cer-form-view-type/cer-form-view-type-tree.component';
import { CerFormViewTypeCustomComponent } from '@form/cer-form-view-type/cer-form-view-type-custom.component';
import { CerFormViewTypeDocumentComponent } from '@form/cer-form-view-type/cer-form-view-type-document/cer-form-view-type-document.component';
import { CerFormViewTypeDocumentMarkdownComponent } from '@form/cer-form-view-type/cer-form-view-type-document/cer-form-view-type-document-markdown.component';
import { CerFormViewTypeDocumentPdfComponent } from '@form/cer-form-view-type/cer-form-view-type-document/cer-form-view-type-document-pdf.component';
import { CerFormViewTypeDocumentGenericComponent } from './cer-form/cer-form-view-type/cer-form-view-type-document/cer-form-view-type-document-generic.component';
import { CerFormViewTypeDocumentFolderComponent } from './cer-form/cer-form-view-type/cer-form-view-type-document/cer-form-view-type-document-folder.component';

import { CerDateEditComponent } from './cer-control/cer-date-edit/cer-date-edit.component';
import { CerGridComponent } from './cer-grid/cer-grid.component';
import { CerStepperComponent } from './cer-stepper/cer-stepper.component';
import { CerMarkdownService } from './cer-markdown/cer-markdown.service';

// Hotkeys
var hotkeyOptions: IHotkeyOptions = {
  disableCheatSheet: false,
  cheatSheetHotkey: '?',
  cheatSheetCloseEsc: true,
  cheatSheetCloseEscDescription: 'Luk denne liste',
  cheatSheetDescription: 'Liste genvejstaster'
};

var cerImports = [
  AngularBaseModule,
  SyncFusionModule,
  MaterialDesignModule,
  PdfViewerModule,
  HotkeyModule.forRoot(hotkeyOptions),
  NgIdleKeepaliveModule.forRoot(),
  CerAuthorizeModule,
];

var cerProviders  = [
  AngularDeviceInformationService,
  CerIdleService,
  CerIntlService,
  CerSessionEnvironmentService,
  CerSessionService,
  CerSessionUserService,
  CerSessionUsersService,
  CerSessionUserNavigationService,
  CerLocaleService,
  CerUiPromptProviderService,
  CerMarkdownService
];

var cerDeclarations = [
  CerViewRecreateDirective,
  CerFormComponent,
  CerFormPaneComponent,
  CerFormComponent,
  CerFormViewComponent,
  CerFormViewTypeListComponent,
  CerFormViewTypeTreeComponent,
  CerFormViewTypeCustomComponent,
  CerFormViewTypeDocumentComponent,
  CerFormViewTypeDocumentMarkdownComponent,
  CerFormViewTypeDocumentPdfComponent,
  CerFormViewTypeDocumentGenericComponent,
  CerFormViewTypeDocumentFolderComponent,
  CerGridComponent,
  CerStepperComponent,
  CerDateEditComponent
]

var cerExports = [].concat(cerDeclarations).concat(cerImports);

@NgModule({
  declarations: cerDeclarations,
  imports: cerImports,
  providers: cerProviders,
  exports: cerExports
})
export class CerModule { }
